import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material";
import { LegendComponent } from "../../../../../common/components/legend_component";
import { useMemo } from "react";
import { GRID_CHECKBOX_SELECTION_FIELD, GridPinnedColumnFields } from "@mui/x-data-grid";
import { isValidId } from "../../../../../common/utils/utils";
import { PatrimonioMaquinaEquipChecklistModal } from "./components/patrimonio_maquina_equip_checklist_modal";
import { LegendTagIcon } from "../../../../../common/components/legend_tag_icon";
import { LegendTagItemComponent } from "../../../../../common/components/legend_tag_item_component";
import { CustomStyledDataGrid } from "./components/custom_styled_data_grid";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { Link as LinkTo } from 'react-router';

import AlertError from "../../../../../common/components/alert_error";
import BottomBar from "../../../../../common/components/bottom_bar";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import { usePatrimonioCadastroInspecaoViewModel } from "../../viewModels/patrimonio_cadastro_inspecao_view_model";
import { GeneratePatrimonioInspecaoCadastroColumnDefinition } from "./columns";
import { PatrimonioMaquinaEquipListaModel } from "../../../domain/models/patrimonio_maquina_equip_lista";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { BackButton } from "../../../../../common/components/back_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import RefreshButton from "../../../../../common/components/refresh_button";
import { Header } from "./components/header";

/**
 * ObrasCadastroarea
 */

export const PatrimonioCadastroInspecao = () => {
  const viewModel = usePatrimonioCadastroInspecaoViewModel();

  const columnsDefinition = useMemo(() => {
    return GeneratePatrimonioInspecaoCadastroColumnDefinition({
      onEnterChecklists: viewModel.handleOpenChecklist,
      onActionEditar: viewModel.handleOpenPatrimonioMaquinaEquipModal,
      onActionDeletar: viewModel.handleDeletePatrimonioMaquinaEquipOpenStateModal,
      //   onActionCopiar: viewModel.handleOpenCopyChecklistAreaModal,
    });
  }, [
    viewModel.handleOpenChecklist,
    viewModel.handleOpenPatrimonioMaquinaEquipModal,
    viewModel.handleDeletePatrimonioMaquinaEquipOpenStateModal,
    // viewModel.handleOpenCopyChecklistAreaModal,
  ]);

  const pinnedColumns = useMemo((): GridPinnedColumnFields => {
    return viewModel.patrimonioMaquinaEquips.length > 0 ?
      {
        left: [
          GRID_CHECKBOX_SELECTION_FIELD,
        ],
        right: [
          'idObraAreaChecklist',
          'copiar',
        ],
      } : {
      };
  }, [
    viewModel.patrimonioMaquinaEquips,
  ]);

  return (
    <>

      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[120px]">
                <PrimaryButton
                  onClick={() => viewModel.handleOpenPatrimonioMaquinaEquipModal(null, true)}
                  startIcon={<DynamicIcon nameIcon="Add" size={25} className="text-white" />}>
                  Novo Item
                </PrimaryButton>
              </div>
              <BackButton
                onClick={viewModel.handleBack}
              />
            </div>
          }
        />
      </PageTopBar>

      {/* <div className="w-[210px]">
        <PrimaryButton
          buttonColor="yellow"
          onClick={() => viewModel.handleOpenIncluirChecklistAreaModal(true)}
          startIcon={<DynamicIcon nameIcon="Add" size={25} className="text-black" />}>
          Incluir Checklist X Área
        </PrimaryButton>
      </div> */}

      {/**
        * Content
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-24">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            <LinkTo to='/'>Home</LinkTo>
          </Link>
          <Link underline="hover" color="inherit" component={'span'}>
            <LinkTo to={`/Patrimonio_maquinaEquip`}>Gestão de Maquina/Equipamento</LinkTo>
          </Link>
          <Typography className="text-primary-green">
            Cadastro de Checklist
          </Typography>
        </Breadcrumbs>

        <div className="flex flex-row gap-8">
          <div className="flex flex-row text-black dark:text-white items-center">
            <span className="font-extrabold text-xl mr-2">Centro de Custo: </span>
            <span className="mx-1 font-base text-base">{viewModel.patrimonioChecklistInfo?.nomeCentroCusto ?? ''}  </span>
          </div>
        </div>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">  Cadastro de Checklist</h1>
            <p>Pesquisar </p>
            <RefreshButton onClick={viewModel.handleReload} />
          </div>
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload}
                />
              </div>
            ) : (
              <>
                <Header
                  descricao={viewModel.filters.descricao}
                  status={viewModel.filters.status}
                  onDescricaoChange={viewModel.handleDescricaoChange}
                  onStatusChange={viewModel.handleStatusChange}
                  onClearFilter={viewModel.handleClearFilter}
                />

                <Stack spacing={0}>
                  <div className="w-full flex flex-row justify-between items-stretch">
                    <div className="flex flex-col flex-wrap">
                      <LegendComponent>
                        <LegendTagItemComponent
                          icon={<LegendTagIcon title='I.A' bgColor="#26C281" />}
                          label='I. Aprovação(%)' />

                        <LegendTagItemComponent
                          icon={<LegendTagIcon title='I.R' bgColor="yellow" />}
                          label='I. Reparo(%)' />

                        <LegendTagItemComponent
                          icon={<LegendTagIcon title='I.RA' bgColor="#FFB848" />}
                          label='I. Reparo Aprovado(%)' />

                        <LegendTagItemComponent
                          icon={<LegendTagIcon title='I.REP' bgColor="#EF4836" />}
                          label='I. Reprovação(%)' />

                      </LegendComponent>
                    </div>
                  </div>

                  <CustomStyledDataGrid
                    tableName="patrimonio_cadastro_inspecao"
                    disableColumnMenu={false}
                    getRowId={(row: PatrimonioMaquinaEquipListaModel) => row.idPatrimonioMaquinaEquip}
                    columns={columnsDefinition}
                    loading={viewModel.loading}
                    rows={viewModel.patrimonioMaquinaEquips}
                    rowCount={viewModel.patrimonioMaquinaEquips.length}
                    pinnedColumns={pinnedColumns}
                    checkboxSelection={true}
                    disableRowSelectionOnClick={true}
                    onRowSelectionModelChange={viewModel.handleRowSelectionModelChange}
                    rowSelectionModel={viewModel.rowSelectionModel}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }}
                  />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />
                </Stack>
              </>
            )
        }
      </div>

      {/**
        * BottomBar
        */}

      < BottomBar >
        <div className="w-full h-full items-center justify-between flex p-4 gap-4">
          <div>
            {
              isValidId(viewModel.idPatrimonioCentroCusto) &&
              <PrimaryButton
                buttonColor="yellow"
                // onClick={() => viewModel.handleOpenChangeHistory(null, null)}>
                onClick={() => { }}>
                <span className="text-xs">
                  Historico de alterações
                </span>
              </PrimaryButton>
            }
          </div>

          {/* <div className="flex flex-row gap-4">
            {
              (viewModel.selectedObraHeaderInfo && viewModel.selectedObraHeaderInfo.status === 0) &&
              <>
                <div className="w-[210px]">
                  <PrimaryButton
                    buttonColor="red"
                    onClick={() => viewModel.handleOpenExcluirChecklistAreaModal(true)}
                    startIcon={<DynamicIcon nameIcon="DeleteForever" size={25} className="text-white" />}>
                    Excluir Checklist X Área
                  </PrimaryButton>
                </div>
                <div className="w-[180px]">
                  <PrimaryButton
                    buttonColor="red"
                    onClick={() => viewModel.handleDeleteLoteObraAreaChecklistOpenStateModal(true)}
                    startIcon={<DynamicIcon nameIcon="DeleteForever" size={25} className="text-white" />}>
                    Excluir selecionados
                  </PrimaryButton>
                </div>
              </>
            }
          </div> */}

        </div>
      </BottomBar>

      {/**
        * Modal Area checklist
        */}

      <PatrimonioMaquinaEquipChecklistModal
        open={viewModel.openPatrimonioMaquinaEquipModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedPatrimonioMaquinaEquip={viewModel.selectedPatrimonioMaquinaEquip ?? null}
        checklistsMaquinaEquip={viewModel.dropDownChecklistMaquinaEquip ?? []}
        onClose={() => viewModel.handleOpenPatrimonioMaquinaEquipModal(null, false)}
        onSubmit={viewModel.handleSubmitPatrimonioMaquinaEquip}
      />

      {/* <IncluirChecklistAreaModal
        open={viewModel.openIncluirChecklistArea}
        saving={viewModel.saving}
        loading={viewModel.loading}
        areas={viewModel.filters.obraAreaChecklists ?? []}
        checklists={viewModel.filters.excOrIncObraChecklistServicos ?? []}
        onClose={() => viewModel.handleOpenIncluirChecklistAreaModal(false)}
        onSubmit={viewModel.handleObraServicosIncluirSubmit}
        onSelectedAreasChange={viewModel.handleSelectedAreasChange}
      /> */}

      {/* <ExcluirChecklistAreaModal
        open={viewModel.openExcluirChecklistArea}
        saving={viewModel.saving}
        loading={viewModel.loading}
        areas={viewModel.filters.obraAreaChecklists ?? []}
        checklists={viewModel.filters.excOrIncObraChecklistServicos ?? []}
        onChecklistChange={viewModel.handleObraAreaExcluirChecklistChange}
        onClose={() => viewModel.handleOpenExcluirChecklistAreaModal(false)}
        onSubmit={viewModel.handleObraServicosExcluirSubmit}
      /> */}

      {/* <CopyChecklistAreaModal
        open={viewModel.openCopyChecklistArea}
        saving={viewModel.saving}
        loading={viewModel.loading}
        onClose={() => viewModel.handleOpenCopyChecklistAreaModal(null, false)}
        onSubmit={viewModel.handleCopyObraAreaChecklistSubmit}
      /> */}

      {/* <DeleteDialog
        open={viewModel.openObraAreaChecklistDelete}
        saving={viewModel.saving}
        title='Você realmente deseja excluir este item?'
        onClose={() => viewModel.handleDeleteObraAreaChecklistOpenStateModal(null, false)}
        onDelete={() => viewModel.handleDeleteObraAreaChecklistConfirm()}
      /> */}

      <DeleteDialog
        open={viewModel.openPatrimonioMaquinaEquipDelete}
        saving={viewModel.saving}
        title='Você realmente deseja excluir os itens selecionados?'
        onClose={() => viewModel.handleDeletePatrimonioMaquinaEquipOpenStateModal(null, false)}
        onDelete={viewModel.handleDeletePatrimonioMaquinaEquipConfirm}
      />

      {/**
        * Modal historico de alterações.
        */}

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />

    </>
  );
}